import React from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Search, Filter } from "lucide-react";

export default function TemplateListFilters() {
  const [params] = useSearchParams();
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const update = (key, value, fallback = "") => {
    const next = new URLSearchParams(params);
    if (value !== fallback) next.set(key, value);
    else next.delete(key);
    next.set("page", "1");
    navigate({ pathname, search: next.toString(), hash }, { replace: true });
  };
  return (
    <div className="flex flex-wrap items-center gap-2 min-w-0 max-w-full">
      <div className="flex items-center gap-2 bg-slate-50 rounded-lg px-3 py-2 border border-slate-100 flex-1 min-w-[12rem]">
        <Search size={14} className="text-slate-400 shrink-0" />
        <input type="text" aria-label="Search templates" placeholder="Search..."
          className="bg-transparent border-none text-xs focus:ring-0 w-full min-w-0 placeholder-slate-400 text-slate-700 p-0"
          value={params.get("q") || ""} onChange={e => update("q", e.target.value)} />
      </div>
      <div className="flex items-center gap-2 bg-slate-50 rounded-lg px-3 py-2 border border-slate-100 shrink-0">
        <Filter size={14} className="text-slate-400" />
        <select aria-label="Template category"
          className="bg-transparent border-none text-[11px] font-semibold text-slate-600 focus:ring-0 cursor-pointer p-0 pr-6"
          value={params.get("category") || "ALL"} onChange={e => update("category", e.target.value, "ALL")}>
          <option value="ALL">All Categories</option>
          <option value="MARKETING">Marketing</option>
          <option value="UTILITY">Utility</option>
          <option value="AUTHENTICATION">Authentication</option>
        </select>
      </div>
    </div>
  );
}
